import { render, staticRenderFns } from "./KycDoc.vue?vue&type=template&id=320887d4&"
import script from "./KycDoc.vue?vue&type=script&lang=js&"
export * from "./KycDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports